module.exports = __webpack_public_path__ + "static/media/logistics.29a87638.svg";